<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Row style="padding-bottom: 10px;margin-top: 10px;">
      <Col span="4" style="padding-right: 10px;">
        <Button type="primary" long @click="onClickSearch">检索燃气用具</Button>
      </Col>
    </Row>
    <Table
      id="customerGasApplicationTable"
      ref="table"
      :width="tWidth"
      :data="showData"
      :columns="showColumns"
      stripe
      border
      highlight-row
      @on-current-change="onTableCurrentChange"
    ></Table>
    <Page
      style="padding-top: 10px;"
      :current="currentPage"
      :total="dataCount"
      :page-size="pageSize"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    ></Page>
    <!-- 模态框insert -->
    <Modal v-model="isShowModal.search" :mask-closable="false" width="380">
      <p slot="header" style="color:#2d8cf0;text-align:center">
        <Icon type="md-create" />
        <span>按照输入的字段检索燃气用具</span>
      </p>
      <Form ref="searchParam" :label-width="100" :model="searchParam">
        <FormItem prop="meterId" label="设备编号：">
          <Input v-model="searchParam.meterId" placeholder="请输入设备编号..."></Input>
        </FormItem>
        <FormItem prop="customerName" label="用户姓名：">
          <Input v-model="searchParam.customerName" placeholder="请输入用户姓名..."></Input>
        </FormItem>
        <FormItem prop="addressLowestLevelAddressId" label="地址：">
          <Cascader
            :data="addressData"
            change-on-select
            filterable
            transfer
            @on-change="chooseAddress"
          ></Cascader>
        </FormItem>
        <FormItem prop="contrastGasAppliancesName" label="燃气用具：">
          <Input v-model="searchParam.contrastGasAppliancesName" placeholder="请输入燃气用具..."></Input>
        </FormItem>
        <FormItem prop="gasAppliancesFixDatestampArray" label="用具安装时间：">
          <Tooltip
            transfer
            placement="top"
            :disabled="searchParam.gasAppliancesFixDatestampArray == undefined 
                        || searchParam.gasAppliancesFixDatestampArray[0] == ''"
            max-width="165"
          >
            <div slot="content">
              <span
                v-if="searchParam.gasAppliancesFixDatestampArray && searchParam.gasAppliancesFixDatestampArray[0] 
                            && searchParam.gasAppliancesFixDatestampArray[1]"
              >{{dateFtt('yyyy-MM-dd',searchParam.gasAppliancesFixDatestampArray[0])}}</span>
              <br />
              <span
                v-if="searchParam.gasAppliancesFixDatestampArray && searchParam.gasAppliancesFixDatestampArray[0] 
                            && searchParam.gasAppliancesFixDatestampArray[1]"
                style="margin-left:50%"
              >~</span>
              <br />
              <span
                v-if="searchParam.gasAppliancesFixDatestampArray && searchParam.gasAppliancesFixDatestampArray[0] 
                            && searchParam.gasAppliancesFixDatestampArray[1]"
              >{{dateFtt('yyyy-MM-dd',searchParam.gasAppliancesFixDatestampArray[1])}}</span>
            </div>
            <DatePicker
              v-model="searchParam.gasAppliancesFixDatestampArray"
              :editable="false"
              type="daterange"
              split-panels
              placeholder="请选择时间区间"
              style="width: 248px"
            ></DatePicker>
          </Tooltip>
        </FormItem>
        <FormItem prop="gasAppliancesExpireDatestampArray" label="用具到期时间：">
          <Tooltip
            transfer
            placement="top"
            :disabled="searchParam.gasAppliancesExpireDatestampArray == undefined 
                        || searchParam.gasAppliancesExpireDatestampArray[0] == ''"
            max-width="165"
          >
            <div slot="content">
              <span
                v-if="searchParam.gasAppliancesExpireDatestampArray && searchParam.gasAppliancesExpireDatestampArray[0] 
                            && searchParam.gasAppliancesExpireDatestampArray[1]"
              >{{dateFtt('yyyy-MM-dd',searchParam.gasAppliancesExpireDatestampArray[0])}}</span>
              <br />
              <span
                v-if="searchParam.gasAppliancesExpireDatestampArray && searchParam.gasAppliancesExpireDatestampArray[0] 
                            && searchParam.gasAppliancesExpireDatestampArray[1]"
                style="margin-left:50%"
              >~</span>
              <br />
              <span
                v-if="searchParam.gasAppliancesExpireDatestampArray && searchParam.gasAppliancesExpireDatestampArray[0] 
                            && searchParam.gasAppliancesExpireDatestampArray[1]"
              >{{dateFtt('yyyy-MM-dd',searchParam.gasAppliancesExpireDatestampArray[1])}}</span>
            </div>
            <DatePicker
              v-model="searchParam.gasAppliancesExpireDatestampArray"
              :editable="false"
              type="daterange"
              split-panels
              placeholder="请选择时间区间"
              style="width: 248px"
            ></DatePicker>
          </Tooltip>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long :loading="isLoadingButton" @click="commitSearch">检索</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "customer_gas_application",
  created() {
    var that = this;
    that.isSpinShow = true;
    $.ajax({
      url: "/api/getAddressTree",
      contentType: "application/json",
      type: "get",
      dataType: "json",
      success: function(data) {
        if (data.errorCode != 0) {
          that.$Notice.error({
            title: "异常",
            desc: data.errorInfo
          });
          return;
        }
        that.addressData = data.body[0].children;
      },
      error: function(textStatus) {
        that.$Notice.error({
          title: "异常",
          desc: "接口请求异常"
        });
      }
    });
    this.showPage();
  },
  mounted(){
    let pushStateSelectDateList = this.pushStateSelectDate;
    this.showColumns = [
      {
        title: "设备编号",
        key: "meterId"
      },
      {
        title: "用户姓名",
        key: "customerName"
      },
      {
        title: "地址",
        key: "addressLowestLevelAddressIds",
        tooltip: true,
        width: 250
      },
      {
        title: "燃气用具",
        key: "contrastGasAppliancesName"
      },
      {
        title: "使用寿命",
        key: "contrastGasAppliancesUsageCycle"
      },
      
      {
        title: "用具安装时间",
        key: "gasAppliancesFixDatestamp",
        render: function(h, params) {
          return h(
            "div",
            global.dateFtt(
              "yyyy-MM-dd",
              new Date(this.row.gasAppliancesFixDatestamp)
            )
          ); /*这里的this.row能够获取当前行的数据*/
        }
      },
      {
        title: "用具到期时间",
        key: "gasAppliancesExpireDatestamp",
        render: function(h, params) {
          return h(
            "div",
            global.dateFtt(
              "yyyy-MM-dd",
              new Date(this.row.gasAppliancesExpireDatestamp)
            )
          ); /*这里的this.row能够获取当前行的数据*/
        }
      },
      {
        title: "到期是否提醒",
        key: "gasAppliancesRemindType",
        render: function(h, params) {
          return h(
            "div",
            row.gasAppliancesRemindType == "1"?"是":"否"
          ); /*这里的this.row能够获取当前行的数据*/
        }
      }
      
      // ,
      // {
      //   title: "推送状态",
      //   key: "pushState",
      //   render: function(h, params){
      //     return h('div', pushStateSelectDateList[this.row.pushState]);
      //   }
      // }
    ];
  },
  data() {
    return {
      tWidth: document.body.clientWidth * 0.8,
      isShowModal: {
        search: false,
        insert: false,
        update: false,
        delete: false
      },
      addressData: [],
      isLoadingButton: false,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      pushStateSelectDate: {
        "0": "未推送",
        "1": "推送成功",
        "2": "用户拒收",
        "3": "系统错误",
        "-1": "微信未返回消息",
        "-2": "微信接口失效"
      },
      showColumns: [],
      currentTableRow: null,
      searchParam: {}
    };
  },
  methods: {
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    showPage() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/viewGasApplication/selectPage?page=" +
          this.currentPage +
          "&pageAmount=" +
          this.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          that.dataCount = data.body.amount;
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    onTableCurrentChange(currentRow, oldCurrentRow) {
      this.currentTableRow = currentRow;
    },
    chooseAddress(param) {
      console.log(param);
      if (param.length > 0) {
        this.searchParam.addressLowestLevelAddressId = param[param.length - 1] * 1; //当复选框选中时则会打印出选中的内容
      } else {
        this.searchParam.addressLowestLevelAddressId = null;
      }
    },
    onClickSearch() {
      this.isShowModal.search = true;
    },
    commitSearch() {
      console.log(this.searchParam);
      this.isShowModal.search = false;
      this.showPage();
    },
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, date);
    }
  }
};
</script>

<style scoped>
#customerGasApplicationTable /deep/ .ivu-table td,
#customerGasApplicationTable /deep/ .ivu-table th {
  min-width: 0;
  height: 30px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}
</style>
